export default __webpack_public_path__ + "static/media/message.05b0e6fa.png";